import React, { Component } from 'react';

import './Button.css';

class Button extends Component {

    constructor(props) {
        super(props)
    }

    isActive = () => {
        return 'tempo-button '+ (this.props.selected ? 'tempo-button-selected':'')
    }

    render = () => {
        return (
            <button className={this.isActive()} {...this.props}>
                {this.props.children}
            </button>
        );
    }
}

export default Button;


// WEBPACK FOOTER //
// ./src/components/Button.js